import * as AlertDialog from '@radix-ui/react-alert-dialog'
import { X, XSquare } from 'phosphor-react'
import { useIntl } from 'react-intl'

type DialogModalProps = {
  isOpen: boolean
  onClose?: () => void
}

export const ErrorModal = ({
  isOpen,
  onClose,
}: DialogModalProps) => {
  const { formatMessage } = useIntl()

  return (
    <AlertDialog.Root open={isOpen}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-50 bg-gray-500 bg-opacity-50" />
        <AlertDialog.Content
          className="flex items-center justify-center fixed h-[216px] z-50 w-10/12 max-w-[560px] -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg top-1/2 left-1/2 "
        >
          <div className='flex items-center px-4 py-5'>
            <XSquare size={40} className="text-[#FF4949] mr-4" />
            <AlertDialog.Title className="font-openSans font-semibold break-words text-2xl text-[#39393a]">
              {formatMessage({ id: 'AN_ERROR_OCCURRED_WHILE_TRYING_TO_MAKE_CONTACT' })}
            </AlertDialog.Title>
            {onClose && (
              <button className="ml-auto absolute right-4 top-4" onClick={onClose}>
                <X size={24} className="text-grey-700" />
              </button>
            )}
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
